// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e8d31502","703":"5b0ca4a6"}[chunkId] + ".chunk.js";
};